export default __webpack_public_path__ + "ebf5926e566164c105bc6c3597fc1c7f.svg";